import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { DateFromTo } from '../date-from-to';
import { DueDatePickerTriggerProps } from './types';

export const ContentToRender = ({ startDate, dueDate, placeholder }) => {
  const today = moment();
  const tomorrow = moment().clone().add(1, 'day');

  if (!startDate && today.isSame(dueDate, 'day')) {
    return <FormattedMessage id="today" />;
  }
  if (!startDate && tomorrow.isSame(dueDate, 'day')) {
    return <FormattedMessage id="tomorrow" />;
  }

  if (startDate || dueDate) {
    return <DateFromTo from={startDate} to={dueDate} />;
  }

  return placeholder || <FormattedMessage id="choose" />;
};

export const DueDatePickerTrigger: FC<DueDatePickerTriggerProps> = ({
  block,
  disabled,
  size,
  hasValue,
  placeholder,
  startDate,
  dueDate,
  onClick,
}) => (
  <Button
    block={block}
    disabled={disabled}
    icon={<EventSchedule16 />}
    size={size}
    type={hasValue ? 'text' : 'link'}
    onClick={onClick}
    data-cy="choose.due.date"
  >
    <ContentToRender
      startDate={startDate}
      dueDate={dueDate}
      placeholder={placeholder}
    />
  </Button>
);
